import { useCallback, useEffect, useRef } from 'react';

// eslint-disable-next-line space-before-function-paren, @typescript-eslint/no-explicit-any
export default function useDebounceCallback<T extends (...args: any[]) => any>(callback: T, delay: number): (...args: Parameters<T>) => void {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback((...args: Parameters<T>) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (callbackRef.current) {
        callbackRef.current(...args);
      }
    }, delay);
  }, [delay]);
}
